import { createRouter } from '@tanstack/react-router';
import { RouteErrorBoundary, RouteNotFound, RoutePending } from './components/shell/RouteError';
import { queryClient } from './lib/queryClient';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  defaultErrorComponent: RouteErrorBoundary,
  defaultPendingComponent: RoutePending,
  defaultNotFoundComponent: RouteNotFound,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
